
const cdnURL = process.env.REACT_APP_CDN_URL;

export const awardArray = [
  { image: `${cdnURL}/images/awards/XOX_Awards_2013.png`, title: "XOX_Awards_2013" },
  { image: `${cdnURL}/images/awards/XOX_Awards_2015.png`, title: "XOX_Awards_2015" },
  { image: `${cdnURL}/images/awards/XOX_Awards_2016.png`, title: "XOX_Awards_2016" },
  { image: `${cdnURL}/images/awards/XOX_Awards_2018.png`, title: "XOX_Awards_2018-MCMC" },
  { image: `${cdnURL}/images/awards/XOX_Awards_2019-MCMC.png`, title: "XOX_Awards_2019-MCMC" },
  { image: `${cdnURL}/images/awards/XOX_Awards_2019-PC.png`, title: "XOX_Awards_2019-PC" },
  { image: `${cdnURL}/images/awards/XOX_Awards_2021.png`, title: "XOX_Awards_2021" },
  { image: `${cdnURL}/images/awards/XOX_Awards_2024.png`, title: "XOX_Awards_2024" },
  { image: `${cdnURL}/images/awards/XOX_Awards_2025.png`, title: "XOX_Awards_2025" },
  { image: `${cdnURL}/images/awards/XOX_Awards_20222023.png`, title: "XOX_Awards_20222023" },
  { image: `${cdnURL}/images/awards/XOX_Awards_201220142015.png`, title: "XOX_Awards_201220142015" },
];

export const milestones = [
  {
    year: "2005",
    points: ["Founded"],
    image: `${cdnURL}/images/milestones/Milestones_2005_Founded.jpg`,
  },
  {
    year: "2008",
    points: ["Signed partnership with <b>Celcom Axiata Berhad</b>"],
    image: `${cdnURL}/images/milestones/Milestones_2008_Signed.jpg`,
  },
  {
    year: "2011",
    points: ["Listed on <b>Bursa Malaysia</b>"],
    image: `${cdnURL}/images/milestones/Milestones_2011_BursaMalaysia.jpg`,
  },
  {
    year: "2013",
    points: ["Official Mobile Technology Partner for <b>Penang State Government</b>"],
    image: `${cdnURL}/images/milestones/Milestones_2013_PGGovernment.jpg`,
  },
  {
    year: "2015",
    points: ["Appointed <b>Datuk Wira Lee Chong Wei as brand ambassador</b>"],
    image: `${cdnURL}/images/milestones/Milestones_2015_LCW.jpg`,
  },
  {
    year: "2017",
    points: ["Partnership with <b>Universal Music Malaysia</b>"],
    image: `${cdnURL}/images/milestones/Milestones_2017_UniversalMusicMalaysia.jpg`,
  },
  {
    year: "2018",
    points: ["Telco Partner for <b>Malaysia Cub Prix (Motorsport)</b>"],
    image: `${cdnURL}/images/milestones/Milestones_2018_Motorsport.jpg`,
  },
  {
    year: "2021",
    points: ["<b>“Best MVNO” at MCMC Star Rating Award</b> for the 2nd time"],
    image: `${cdnURL}/images/milestones/Milestones_2021_MVNO.jpg`,
  },
  {
    year: "2022",
    points: ["Partnership with <b>Ant Group</b>", "Customised mobile plans for <b>9 MFL Super League teams</b>", "Launched <b>MYSISWA Digital Lifestyle</b> endorsed by MoHE"],
    image: `${cdnURL}/images/milestones/Milestones_2022_AntGroup.jpg`,
  },
  {
    year: "2023",
    points: ["White-label partnership with <b>UCSI Group's UniComms</b>"],
    image: `${cdnURL}/images/milestones/Milestones_2023_UniComms.jpg`,
  },
  {
    year: "2024",
    points: ["Tourism Perak’s Partner for <b>Visit Perak 2024 initiative</b>","Launched <b>5G Travel eSIM</b> with KDDI & China Mobile"],
    image: `${cdnURL}/images/milestones/Milestones_2024_PERAK.jpg`,
  },
  {
    year: "2025",
    points: ["Distinguished recipient of the <b>Best MVNO Award 2025</b>","Malaysia's first Postpaid Plan with <b>free roaming in 88 countries</b>","Strategic collaboration with <b>MyDigital ID</b>","Co-brand partnerships with <b>TikTok Shop & Handal Indah</b>"],
    image: `${cdnURL}/images/milestones/Milestones_2025_MVNO.jpg`,
  },
  {
    year: "2026",
    points: ["Launched ETS38 mobility plan in collaboration with <b>KTMB and ETS</b>, allowing users to subscribe and redeem ETS tickets through XOX mobile plans"],
    image: `${cdnURL}/images/milestones/Milestones_2026_KLSentral.jpg`,
  },
];